import React, { useState, useEffect } from 'react';
import styled from '../../../../styled';
import dayjs, { getLocaleKey } from '../../date/day';
import { Grid as GridComponent } from '../../date/Calendar';
import CalendarHeader from '../../date/Calendar/CalendarHeader';
import DateCalendarView from '../../date/Calendar/DateCalendarView';
import MonthCalendarView from '../../date/Calendar/MonthCalendarView';
import YearCalendarView from '../../date/Calendar/YearCalendarView';
import TimeSelector from './TimeSelector';
const TimeSelctorGrid = styled.div `
  width: 7.5rem;
  border-left: 0.0625rem solid ${({ theme }) => theme.colors.INK_200};
  margin-left: 1rem;
`;
const RangeGridContainer = styled.div `
  display: flex;
  cursor: default;
`;
const StyledGrid = styled(GridComponent) `
  padding-right: 1rem;
  padding-bottom: 1rem;
`;
const Calendar = ({ lang = 'en', format, open, isFocusOnToInput = false, selectedDate, selectedFrom, selectedTo, value, valueFrom, valueTo, onDateChange = () => { }, onTimeChange = () => { }, disabledDate = () => false, }) => {
    const [mode, setMode] = useState('DATE');
    const [targetDate, setTagetDate] = useState((selectedDate || selectedFrom || selectedTo || dayjs(lang))
        .set('minute', 0)
        .set('second', 0)
        .locale(getLocaleKey(lang)));
    const onPageChanged = (diff) => () => {
        let newDate;
        if (mode === 'DATE') {
            newDate = targetDate.add(diff, 'month');
        }
        else if (mode === 'MONTH') {
            newDate = targetDate.add(diff, 'year');
        }
        else {
            newDate = targetDate.add(diff * 10, 'year');
        }
        setTagetDate(newDate);
    };
    const onMonthChanged = (m) => {
        setTagetDate(targetDate.month(m));
        setMode('DATE');
    };
    const onYearChanged = (y) => {
        setTagetDate(targetDate.year(y));
        setMode('MONTH');
    };
    useEffect(() => {
        const date = isFocusOnToInput ? selectedTo : selectedFrom;
        if (date)
            setTagetDate(date.clone());
    }, [isFocusOnToInput, open, selectedFrom, selectedTo]);
    const header = (React.createElement(CalendarHeader, { lang: lang, mode: mode, target: targetDate, onPrevPage: onPageChanged(-1), onNextPage: onPageChanged(1), onChangeMode: setMode }));
    if (mode === 'DATE') {
        return (React.createElement(RangeGridContainer, null,
            React.createElement(GridComponent, null,
                header,
                React.createElement(DateCalendarView, { lang: lang, target: targetDate, selectedDate: selectedDate, selectedFrom: selectedFrom, selectedTo: selectedTo, onSelect: onDateChange, disabledDate: disabledDate })),
            React.createElement(TimeSelctorGrid, null,
                React.createElement(TimeSelector, { lang: lang, format: format, selectedDate: selectedDate || (isFocusOnToInput ? selectedTo : selectedFrom), inputValue: value || (isFocusOnToInput ? valueTo : valueFrom), onSelect: onTimeChange }))));
    }
    return (React.createElement(StyledGrid, null,
        header,
        mode === 'MONTH' && (React.createElement(MonthCalendarView, { lang: lang, target: targetDate, selectedDate: selectedDate, selectedFrom: selectedFrom, selectedTo: selectedTo, onSelect: onMonthChanged })),
        mode === 'YEAR' && (React.createElement(YearCalendarView, { target: targetDate, selectedDate: selectedDate, selectedFrom: selectedFrom, selectedTo: selectedTo, onSelect: onYearChanged }))));
};
export default Calendar;
//# sourceMappingURL=index.js.map